<div class="login-content mx-auto">          
  <h3 class="caption-login mb-3" style="padding-top:40px;"></h3>
  <p>{{changePasswordconstant.CHANGE_PASSWORD_HEADER_TEXT}}</p>
  <form [formGroup]="changePasswordForm" (ngSubmit)="ChangePassword()" #changePassword="ngForm">
      <div class="form-group mb-4">
        <label>{{changePasswordconstant.OLD_PASSWORD}}<span class="asterisk">*</span></label>
        <div class="input-group">
          <input [type]="IsShowOldPassword ? 'text' : 'password'" class="form-control" formControlName="oldPassword" placeholder="Enter Old Password" maxlength="15" oninput="this.value = this.value.replace(/^\s+/g, '')"/>
          <div _ngcontent-fuk-c6="" class="input-group-append">
            <div _ngcontent-fuk-c6="" class="input-group-text">
              <span _ngcontent-fuk-c6="" [class]="IsShowOldPassword ? 'fa fa-eye-slash' :'fa fa-eye'" (click)="showOldPassword()"></span>
            </div>
          </div>
        </div>
        <span class="text-danger" *ngIf="isSubmitted && changePassword.submitted && changePasswordFormControl['oldPassword']?.errors?.['required']">{{errorMessage.OldPasswordRequired}}</span>
      </div>
      <div class="form-group mb-4">
        <label>{{changePasswordconstant.NEW_PASSWORD}}<span class="asterisk">*</span></label>
        <div class="input-group">
          <input [type]="IsShowNewPassword ? 'text' : 'password'" class="form-control" formControlName="newPassword" placeholder="Enter New Password" maxlength="15"  oninput="this.value = this.value.replace(/^\s+/g, '')"/>
          <div _ngcontent-fuk-c6="" class="input-group-append">
            <div _ngcontent-fuk-c6="" class="input-group-text">
                <span _ngcontent-fuk-c6="" [class]="IsShowNewPassword ? 'fa fa-eye-slash' :'fa fa-eye'" (click)="showNewPassword()"></span>
            </div>
          </div>
        </div>
        <span class="text-danger" *ngIf="isSubmitted && changePassword.submitted &&changePasswordFormControl['newPassword']?.errors?.['required']">{{errorMessage.NewPasswordRequired}}</span>
        <span class="text-danger" *ngIf="isSubmitted && changePassword.submitted && changePasswordFormControl['newPassword']?.errors?.['pattern']">{{errorMessage.PasswordPattern}}</span>
      </div>
      <div class="form-group mb-4">
        <label>{{changePasswordconstant.CONFIRM_NEW_PASSWORD}}<span class="asterisk">*</span></label>
        <div class="input-group">
          <input [type]="IsShowConfirmPassword ? 'text' : 'password'" class="form-control" formControlName="ConfirmPassword" placeholder="Enter Confirm New Password" maxlength="15" oninput="this.value = this.value.replace(/^\s+/g, '')"/>
          <div _ngcontent-fuk-c6="" class="input-group-append">
            <div _ngcontent-fuk-c6="" class="input-group-text">
              <span _ngcontent-fuk-c6="" [class]="IsShowConfirmPassword ? 'fa fa-eye-slash' :'fa fa-eye'" (click)="showConfirmPassword()"></span>
            </div>
          </div>
        </div>
        <span class="text-danger"
        *ngIf="isSubmitted && changePassword.submitted && changePasswordFormControl['ConfirmPassword']?.errors?.['required']">{{errorMessage.ConfirmNewPassword}}</span>
        <span class="text-danger" *ngIf="isSubmitted && changePassword.submitted && changePasswordFormControl?.['ConfirmPassword']?.errors?.['pattern']">{{errorMessage.PasswordPattern}}</span>
      </div>
      <button class="btn btn-primary login-btn mt-3 mb-5" type="submit">{{changePasswordconstant.CHANGE_PASSWORD}}</button>
  </form>
</div>
